import { untrack } from "svelte";
import { dispatchSheetEvent } from "../event/event.dispatch";
import * as EVENT_DEFS from "../event/event.name.defs";
import { stack } from "./stack.global.svelte";
import { findInstance, stackScope } from "./stack.utils";
import { current, type OcSheetV1CurrentState } from "../index.js";

const log = stackScope.scope("events");

/**
 *
 */
export const useStackEvents = (): void => {
  $effect.root(() => {
    $effect(() => {
      if (
        !!stack.current &&
        stack.prev.length === 0 &&
        stack.visited.length === 0 &&
        stack.isPushing
      ) {
        const instance = findInstance(stack.current);
        if (!instance) return log.warn("Presentation start without active instance.");

        dispatchSheetEvent(EVENT_DEFS.PRESENTATION_START, instance, { info: stack.info });
      }

      if (
        !stack.current &&
        stack.prev.length === 0 &&
        stack.visited.length > 0 &&
        !stack.isPopping
      ) {
        stack.visited.splice(0).forEach((visitedId) => {
          const instance = findInstance(visitedId);
          if (!instance) return log.warn("Presentation end without visited instance", visitedId);

          dispatchSheetEvent(EVENT_DEFS.PRESENTATION_END, instance, { info: stack.info });
        });
      }
    });

    $effect(() => {
      const [action, reason, length] = untrack(() => [
        stack.action[0],
        stack.reason,
        stack.popLength,
      ]);

      const data: OcSheetV1CurrentState = stack.current
        ? {
            id: stack.current,
            instance: findInstance(stack.current),
            isActive: !!stack.current,
            action,
            reason,
            length,
          }
        : { id: null, instance: null, isActive: false, action: null, reason: null, length: 0 };

      current.set(data);
    });
  });
};
